<template>
  <div>
    <div v-if="form">
      <div>
        <p><b>Location</b></p>
        <vue-google-autocomplete
          class="outlined"
          id="searchbox"
          :country="['il', 'ps']"
          :types="types"
          placeholder="הקלד/י מיקום..."
          @change="updateAddress"
          @placechanged="updateLatLong"
          v-model="form.data.location.fields.description.value">
        </vue-google-autocomplete>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
export default {
  name: 'locations-form',
  props: ['payload', 'onSubmit'],
  data () {
    return {
      types: this.payload.resource_type == 'Applicant' ? '(regions)' : 'geocode',
      is_loading: false,
      form: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        return
      }
      this.$network_utils.getResourceLocations({ current_type: this.payload.resource_type, current_resource_id: this.payload.resource_id }).then(response => {
        this.setForm(response[0])
      })
    },
    updateLatLong (address_data) {
      this.form.data.location.fields.lat.value = address_data.latitude
      this.form.data.location.fields.long.value = address_data.longitude
    },
    updateAddress (address) {
      this.form.data.location.fields.description.value = address
    },
    setForm (form_data) {
      this.form = new this.$form({
        location: {
          fields: {
            lat: {
              value: form_data.lat,
              has_error: false,
              validations: []
            },
            long: {
              value: form_data.long,
              has_error: false,
              validations: []
            },
            description: {
              value: form_data.description,
              has_error: false,
              validations: []
            },
            current_type: {
              value: this.payload.resource_type,
              has_error: false,
              validations: []
            },
            current_resource_id: {
              value: this.payload.resource_id,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/locations/' + form_data.id,
            headers: 'shared_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        if (this.payload.resource_type == 'Position') {
          this.$network_utils.sendPositionUpdateEvent({ position_id: this.payload.resource_id, company_id: this.payload.company_id, status: this.payload.position_status })
        }
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        if (this.onSubmit) {
          this.onSubmit(this.form.data.location.fields.description.value)
        }
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  },
  components: {
    VueGoogleAutocomplete
  }
}
</script>
